<template>
  <div
    class="container mx-auto min-h-screen flex flex-col items-center justify-center"
  >
    <img src="@/convite/assets/images/timbeta-logo.png" class="h-16 rounded-lg" />
    <p class="text-2xl mt-2">Bem vindo ao Novo Tim Beta</p>

    <div class="flex items-center mt-5 space-x-4">
      <img
        class="h-16"
        src="@/convite/assets/images/google-play-badge.png"
        alt="Baixar na google play"
      />
      <img
        class="h-12"
        src="@/convite/assets/images/apple-store-badge.svg"
        alt="Baixar na play store"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style lang="scss" scoped>
@import "../convite/assets/styles/variables";


</style>
